import { Container } from "reactstrap";

export const CopyrightFooter: React.FC = () => {
    return <Container className="py-2 text-right"><footer>Copyright © 2023 CubeConLLC - All Rights Reserved.</footer></Container>;
}